module.exports = __webpack_public_path__ + "pic3.2d080fb3893d21eedc0d.jpg";


//////////////////
// WEBPACK FOOTER
// /home/alinu/Alin/Work/Workspace/BART-client/src/assets/img/pic3.jpg
// module id = ../../../../../src/assets/img/pic3.jpg
// module chunks = main